import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type AiMatchScoreMatchScoreFragment = { __typename?: 'AiMatchScore', lifePlanningMatchingScore: number, onetimeSaleMatchingScore: number, householdImprovementMatchingScore: number, sellingHomeMatchingScore: number, realEstateInvestmentMatchingScore: number, jobChangeMatchingScore: number };

export const AiMatchScoreMatchScoreFragmentDoc = gql`
    fragment AiMatchScoreMatchScore on AiMatchScore {
  lifePlanningMatchingScore
  onetimeSaleMatchingScore
  householdImprovementMatchingScore
  sellingHomeMatchingScore
  realEstateInvestmentMatchingScore
  jobChangeMatchingScore
}
    `;